
import './assets/styles/main.scss';

import AuditTrailRoutes from './routes';

export default AuditTrailRoutes;